import React, { useEffect, useRef, useState } from 'react';
import '../../css/PhilosophySection.css';

function AnimatedLine({ children, delay }) {
  return (
    <p
      className="text-xl md:text-2xl font-normal tracking-wide leading-relaxed opacity-0 animate-fade-in-line whitespace-pre-line"
      style={{
        animationDelay: `${delay}s`,
        animationFillMode: 'forwards',
        animationDuration: '0.8s',
        animationTimingFunction: 'ease-out',
      }}
    >
      {children}
    </p>
  );
}

function PhilosophySection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    let hasAppeared = false;
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAppeared) {
          setShouldAnimate(true);
          setVisible(true);
          hasAppeared = true;
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const lines = [
  'シャルンは、通信業界のセールスプロモーションを得意とする企業です。',
  'リアルな店舗などの オフライン と、インターネットを活用した オンライン を組み合わせ、',
  '集客から販売までを一貫して最適化することを強みとしています。',
  '　',
  'オンラインとオフラインをつなぐプロモーションは、成果を左右する重要なポイントです。',
  '私たちは、その両面を熟知したプロフェッショナルとして、',
  '最適な戦略立案から施策運用、効果改善までをワンストップでサポートし、',
  'クライアントの利益最大化に貢献いたします。'
  ];


  return (
    <section
      ref={ref}
      className={`relative philosophy-clipped-section ${visible ? 'opacity-100' : 'opacity-0'}  mt-30 bg-gradient-to-br from-black to-gray-500 text-white p-6 md:p-12 backdrop-blur-md`}
      style={{
        willChange: 'opacity',
        transition: shouldAnimate ? 'opacity 1.2s cubic-bezier(.4,0,.2,1)' : 'none',
        minHeight: '180vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center'
      }}
      onTransitionEnd={() => setShouldAnimate(false)}
    >
      <video
        className="absolute inset-0 w-full h-full object-cover -z-10"
        src={`${process.env.PUBLIC_URL}/video/about.mp4`}
        autoPlay
        loop
        muted
        playsInline
      />
      <h2 id="philosophy" className="text-3xl md:text-5xl font-black tracking-tight mb-12 border-b border-white/100 pb-2">
        About
      </h2>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm -z-10" />
      <div className="space-y-4">
        {visible &&
          lines.map((line, i) => (
            <AnimatedLine key={i} delay={i * 0.6}>
              {line}
            </AnimatedLine>
          ))}
      </div>
    </section>
  );
}

export default PhilosophySection;
